export default "__VITE_ASSET__6bb8b647__"